import { Pagination, TravelListing } from "components";
import { useNavigate } from "react-router-dom";

import EmptyState from "assets/images/img-empty-state.svg";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getTripRequests } from "services/trip-request";
import { RootState } from "store";
import styles from "./styles.module.scss";

type Trip = {
	id: string;
	status: string;
	createdAt: string;
	departure: string;
	arrival: string;
	date: string;
	numberPassengers: number;
};

const pageSize = 6;

export default function TravelsPage() {
	const navigate = useNavigate();

	const { logged_user } = useSelector((state: RootState) => state.tokens);

	const [trips, setTrips] = useState<Trip[]>([]);
	const [pageNumber, setPageNumber] = useState(1);
	const [pageTrips, setPageTrips] = useState<Trip[]>([]);

	const fetchData = async () => {
		if (!logged_user) return;

		const allTrips = (await getTripRequests()) ?? [];

		allTrips.sort((a: any, b: any) => {
			const dateA = new Date(a.created_at).getTime();
			const dateB = new Date(b.created_at).getTime();
			return dateB - dateA;
		});

		const apiTripRequests = allTrips
			.map((trip: any) => ({
				...trip,
				origin: trip.points.find((point: any) => point.type === "origin"),
				destination: trip.points.find(
					(point: any) => point.type === "destination"
				)
			}))
			.filter((trip: any) => trip.origin && trip.destination)
			.map((trip: any) => ({
				id: trip.id,
				status: trip.status,
				createdAt: new Date(trip.created_at).toLocaleDateString("pt-BR"),
				departure: trip.origin.city,
				arrival: trip.destination.city,
				date: new Date(trip.origin.datetime).toLocaleDateString("pt-BR"),
				numberPassengers: trip.num_adults + trip.num_children + trip.num_pets
			}));

		setTrips(apiTripRequests);
		setPageTrips(apiTripRequests.slice(0, pageSize));
	};

	useEffect(() => {
		fetchData();
	}, []);

	const getLabel = (travel: Trip) => {
		switch (travel.status) {
			case "new":
				return "-";
			case "pending":
				return "Nova viagem";
			case "accepted":
				return "Pagamento pendente";
			case "paid":
				return "Agendada";
			case "completed":
				return "Finalizada";
			case "cancelled":
				return "Cancelada";
			default:
				return "-";
		}
	};

	const getPath = (travel: Trip) => {
		switch (travel.status) {
			case "new":
				return "";
			case "pending":
				return "nova-viagem";
			case "accepted":
				return "pagamento-pendente";
			case "paid":
				return "agendada";
			case "completed":
				return "finalizada";
			case "cancelled":
				return "cancelada";
			default:
				return "";
		}
	};

	const onPageChange = (newPage: number) => {
		setPageNumber(newPage);
		const startIndex = (newPage - 1) * pageSize;
		const endIndex = startIndex + pageSize;
		setPageTrips(trips.slice(startIndex, endIndex));
	};

	return (
		<div className={styles.container}>
			<div className={styles.travelsHeader}>
				<span>Viagens</span>
			</div>
			{trips.length === 0 && (
				<div className={styles.travelEmptyState}>
					<img src={EmptyState} alt="Nenhuma viagem encontrada" />
					<h2>Pronto para a primeira viagem!</h2>
					<span>Responda rápido e conquiste seus clientes</span>
				</div>
			)}
			<div className={styles.travelListing}>
				{pageTrips.map((trip) => (
					<TravelListing
						createdAt={trip.createdAt}
						arrival={trip.arrival}
						departure={trip.departure}
						date={trip.date}
						passengers={`${trip.numberPassengers} passageiro${
							trip.numberPassengers > 1 ? "s" : ""
						}`}
						status={getLabel(trip)}
						onClick={() => navigate(`/viagens/${trip.id}/${getPath(trip)}`)}
					/>
				))}
			</div>
			<div className={styles.paginationMargin}>
				<Pagination
					currentPage={pageNumber}
					totalPages={Math.ceil(trips.length / pageSize)}
					onPageChange={onPageChange}
				/>
			</div>
		</div>
	);
}
